import React, {FC} from 'react';
import styled from 'styled-components';

import {Skeleton, SkeletonColorSchemesEnum} from '../../../../../../../../../src/components/common/skeleton';
import {CrmSyncSourcesEnum} from '../../../../../../../../../src/models/api/crmSyncModel';
import {SectionDividerDiv} from '../crmSyncsForm';
import {useCrmPageConfig} from '../crmSyncsPageConfig/crmSyncsPageConfig';

/*
 * Props.
 */

export interface CrmSyncsLoadingFormProps {
  source: CrmSyncSourcesEnum;
}

/*
 * Styles.
 */

const StyledLoadingStateWrapperDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 21px 0;
`;

const StyledLoadingStateLinesDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

/*
 * Component.
 */

export const CrmSyncsLoadingForm: FC<CrmSyncsLoadingFormProps> = ({source}) => {
  const {account, card} = useCrmPageConfig(source);
  return (
    <>
      {account && (
        <>
          <SectionDividerDiv />
          {renderLoadingSection()}
          <SectionDividerDiv />
        </>
      )}
      {card && (
        <>
          {renderLoadingSection()}
          <SectionDividerDiv />
        </>
      )}
    </>
  );
};

function renderLoadingSection() {
  return (
    <StyledLoadingStateWrapperDiv>
      <Skeleton width="40px" height="40px" borderRadius="50%" scheme={SkeletonColorSchemesEnum.GREY10} />
      <StyledLoadingStateLinesDiv>
        <Skeleton width="215px" height="16px" borderRadius="8px" scheme={SkeletonColorSchemesEnum.GREY30} />
        <Skeleton width="455px" height="16px" borderRadius="8px" scheme={SkeletonColorSchemesEnum.GREY10} />
      </StyledLoadingStateLinesDiv>
    </StyledLoadingStateWrapperDiv>
  );
}
